import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, map, Observable } from 'rxjs';

@Component({
  selector: 'app-carousel-summary-structure',
  templateUrl: './carousel-summary-structure.component.html',
  styleUrls: ['./carousel-summary-structure.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselSummaryStructureComponent implements OnInit, OnDestroy {
  @Input() public data: any[] = [];

  public current$: Observable<any>;

  private _slideIndex$ = new BehaviorSubject(0);

  public ngOnInit() {
    this.current$ = this._slideIndex$.pipe(map((index) => this.data[index]));
  }

  public ngOnDestroy() {
    this._slideIndex$.complete();
  }

  public onChange(index: number) {
    this._slideIndex$.next(index);
  }
}
